import React from 'react'
import Select from 'react-select'
import {
  Autocomplete,
  CircularProgress,
  MenuItem,
  TextField
} from '@mui/material'
import { getReactSelectStyles } from '../../helpers/specialPriceHelpers'
import {
  SPECIAL_PRICE_CREATE_AUTOCOMPLETE_SX,
  SPECIAL_PRICE_CREATE_CLIENT_MIN_SEARCH_LENGTH,
  SPECIAL_PRICE_CREATE_FIELD_LABELS,
  SPECIAL_PRICE_CREATE_MESSAGES,
  SPECIAL_PRICE_CREATE_SCOPE_OPTIONS,
  SPECIAL_PRICE_CREATE_SCOPE_SELECT_SX,
  SPECIAL_PRICE_CREATE_PLACEHOLDERS,
  SPECIAL_PRICE_CREATE_STEP_CONTENT
} from '../specialPriceCreateConstants'

const SpecialPriceScopeStep = ({
  attributeDefinitions,
  attributeFilters,
  attributeScopeUnavailable,
  clientError,
  clientOptions,
  clientSearchInput,
  fieldErrors,
  isClientLoading,
  onAttributeSelectChange,
  onClientChange,
  onClientInputChange,
  onScopeTypeChange,
  scopeType,
  selectedClient
}) => {
  return (
    <div className="task-form-section">
      <div className="title-promos-form">
        <b>{SPECIAL_PRICE_CREATE_STEP_CONTENT.scope.title}</b>
      </div>
      <p>{SPECIAL_PRICE_CREATE_STEP_CONTENT.scope.description}</p>
      <hr className="hr-task-form" />

      <div className="special-price-create-control-wrap">
        <TextField
          select
          fullWidth
          size="small"
          label={SPECIAL_PRICE_CREATE_FIELD_LABELS.scopeType}
          value={scopeType}
          onChange={onScopeTypeChange}
          error={Boolean(fieldErrors.scope_type)}
          sx={SPECIAL_PRICE_CREATE_SCOPE_SELECT_SX}
        >
          <MenuItem value="">{SPECIAL_PRICE_CREATE_FIELD_LABELS.scopeType}</MenuItem>
          {SPECIAL_PRICE_CREATE_SCOPE_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
      {fieldErrors.scope_type && (
        <div className="invalid-feedback d-block">{fieldErrors.scope_type}</div>
      )}

      {scopeType === 'client' && (
        <div className="task-form-section">
          <div className="title-promos-form">
            <b>{SPECIAL_PRICE_CREATE_STEP_CONTENT.client.title}</b>
          </div>
          <p>{SPECIAL_PRICE_CREATE_STEP_CONTENT.client.description}</p>
          <hr className="hr-task-form" />

          <Autocomplete
            fullWidth
            size="small"
            options={clientOptions}
            value={selectedClient}
            inputValue={clientSearchInput}
            loading={isClientLoading}
            onChange={(_event, option) => onClientChange(option)}
            onInputChange={onClientInputChange}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            getOptionLabel={(option) => option?.label || ''}
            filterOptions={(options) => options}
            noOptionsText={
              clientSearchInput.trim().length < SPECIAL_PRICE_CREATE_CLIENT_MIN_SEARCH_LENGTH
                ? SPECIAL_PRICE_CREATE_MESSAGES.clientMinSearch
                : SPECIAL_PRICE_CREATE_MESSAGES.clientNoResults
            }
            clearOnBlur={false}
            componentsProps={{
              popper: {
                placement: 'bottom-start',
                modifiers: [
                  {
                    name: 'flip',
                    enabled: false
                  }
                ]
              }
            }}
            sx={SPECIAL_PRICE_CREATE_AUTOCOMPLETE_SX}
            renderInput={(params) => (
              <TextField
                {...params}
                label={SPECIAL_PRICE_CREATE_FIELD_LABELS.clientSearch}
                error={Boolean(fieldErrors.client || clientError)}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {isClientLoading ? <CircularProgress color="inherit" size={16} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  )
                }}
              />
            )}
          />
          {(fieldErrors.client || clientError) && (
            <div className="invalid-feedback d-block">{fieldErrors.client || clientError}</div>
          )}
        </div>
      )}

      {scopeType === 'attribute' && (
        <div className="task-form-section">
          <div className="title-promos-form">
            <b>{SPECIAL_PRICE_CREATE_STEP_CONTENT.attribute.title}</b>
          </div>
          <p>{SPECIAL_PRICE_CREATE_STEP_CONTENT.attribute.description}</p>
          <hr className="hr-task-form" />

          {attributeDefinitions.map((definition, index) => {
            const isAttributeEnabled = index === 0

            return (
              <div
                className="task-form-control-width special-price-create-attribute-field"
                key={definition.key}
              >
                <div className="qualifier-title">{`Atributo ${String.fromCharCode(65 + index)}`}</div>
                <div
                  className="fake-validator-container"
                  style={{ zIndex: attributeDefinitions.length - index }}
                >
                  <Select
                    placeholder={SPECIAL_PRICE_CREATE_PLACEHOLDERS.attributeSearch}
                    noOptionsMessage={() => SPECIAL_PRICE_CREATE_MESSAGES.clientNoResults}
                    loadingMessage={() => 'Cargando...'}
                    className="qualifier"
                    isClearable
                    isDisabled={!isAttributeEnabled}
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                    menuPosition="fixed"
                    onChange={(option) => onAttributeSelectChange(definition.key, option)}
                    options={definition.options}
                    value={
                      attributeFilters[definition.key]
                        ? definition.options.find(
                            (option) => option.value === attributeFilters[definition.key]
                          ) || null
                        : null
                    }
                    styles={getReactSelectStyles()}
                  />
                </div>
              </div>
            )
          })}

          {(fieldErrors.attribute || attributeScopeUnavailable) && (
            <div className="invalid-feedback d-block mt-10">
              {fieldErrors.attribute || SPECIAL_PRICE_CREATE_MESSAGES.attributeUnavailable}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default SpecialPriceScopeStep
